import { powerSyncCollectionOptions } from "@tanstack/powersync-db-collection";
import { createCollection } from "@tanstack/react-db";
import { z } from "zod";
import { AppSchema } from "@/lib/powersync-schema.generated";
import { collectionBase } from "./_factory";
import { syncedRow } from "./synced-row";

export const SelectGuestIdentitySchema = syncedRow({
  createdAt: z.string(),
  externalData: z.string().nullable(),
  externalId: z.string().nullable(),
  guestId: z.string(),
  id: z.string(),
  propertyId: z.string(),
  transport: z.string().nullable(),
  updatedAt: z.string(),
});

export type GuestIdentity = z.infer<typeof SelectGuestIdentitySchema>;

export const guestIdentitiesCollection = createCollection(
  powerSyncCollectionOptions({
    ...collectionBase("guest identity"),
    schema: SelectGuestIdentitySchema,
    table: AppSchema.props.guest_identities,
  })
);
